import React from 'react';
import PropTypes from 'prop-types';

// Multibrand-UI Components
import HelpCircleFill from '@zg-rentals/multibrand-ui/lib/icons/HelpCircleFill';
import Tooltip from '@zg-rentals/multibrand-ui/lib/Tooltip';

// Stylesheets
import './style.scss';

const propTypes = {
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
};

function HeaderTooltip({ title, message }) {
    return (
        <div className="HeaderTooltip">
            <div className="HeaderTooltip-title">{title}</div>
            <Tooltip
                trigger="hover"
                type="primary"
                targetClass="Tooltip-Tooltip-target"
                className="Tooltip-Tooltip"
            >
                <Tooltip.Target>
                    <HelpCircleFill size="sm" />
                </Tooltip.Target>
                <div className="HeaderTooltip-text">{message}</div>
            </Tooltip>
        </div>
    );
}

HeaderTooltip.propTypes = propTypes;

export default HeaderTooltip;
